module.exports = __webpack_public_path__ + "img/price-1-star.85d6719a.png";